import { LegacyCard, LegacyStack, Select } from "@shopify/polaris";
import { BillingRecoveryMethodOptionEnum } from "@smartrr/shared/entities/Organization";
import { Subheading } from "../..";

interface BillingRecoveryMethodSettingProps {
  billingRecoveryMethod: BillingRecoveryMethodOptionEnum | null | undefined;
  setBillingRecoveryMethod: React.Dispatch<
    React.SetStateAction<BillingRecoveryMethodOptionEnum | null | undefined>
  >;
}

const billingRecoveryMethodOptions = [
  {
    label: "Payment methods not used by other active subscriptions shipping to a different city",
    value: BillingRecoveryMethodOptionEnum.LOCATION_SAFE_PAYMENT_METHODS,
  },
  {
    label: "All payment methods",
    value: BillingRecoveryMethodOptionEnum.ALL_PAYMENT_METHODS,
  },
];

export function BillingRecoveryMethodSetting({
  billingRecoveryMethod,
  setBillingRecoveryMethod,
}: BillingRecoveryMethodSettingProps) {
  return (
    <LegacyCard.Section title="Payment method recovery">
      <Subheading className="card-subheading">
        Failed payments will be retried automatically using other payment methods saved by the customer in their
        profile. This setting allows you to define which payment methods will be retried.
      </Subheading>
      <LegacyStack vertical spacing="tight">
        <Select
          label="Retry payments with"
          options={billingRecoveryMethodOptions}
          value={billingRecoveryMethod || ""}
          onChange={value => {
            setBillingRecoveryMethod(value as BillingRecoveryMethodOptionEnum);
          }}
          helpText="The payment methods to retry when a payment fails"
        />
      </LegacyStack>
    </LegacyCard.Section>
  );
}
